<serviceos-web-card>
    <serviceos-web-tabs
        *ngIf="screen === 'login' || screen === 'create-account'"
        (changeScreenEvent)="onChangeScreen($event)"
        [screen]="screen"
    ></serviceos-web-tabs>
    <serviceos-web-login
        *ngIf="screen === 'login'"
        (changeScreenEvent)="onChangeScreen($event)"
    ></serviceos-web-login>
    <serviceos-web-register
        *ngIf="screen === 'create-account'"
        (changeScreenEvent)="onChangeScreen($event)"
    ></serviceos-web-register>
    <serviceos-web-reset-password
        *ngIf="screen === 'forgot-password'"
        (changeScreenEvent)="onChangeScreen($event)"
    ></serviceos-web-reset-password>
    <serviceos-web-claim-account
        *ngIf="screen === 'claim-account'"
        (changeScreenEvent)="onChangeScreen($event)"
    ></serviceos-web-claim-account>
    <serviceos-web-footnote-box
        *ngIf="screen === 'login' || screen === 'create-account'"
        (changeScreenEvent)="onChangeScreen($event)"
    ></serviceos-web-footnote-box>
</serviceos-web-card>
